export default "__VITE_ASSET__B72wRZQR__"